import { transpileBlock } from "./scratchTranspiler";

export const convertScratchToCpp = (projectData) => {
  try {
    let projectObj = projectData;
    if (typeof projectData === "string") {
      if (!projectData.trim()) {
        projectObj = null;
      } else {
        try {
          projectObj = JSON.parse(projectData);
        } catch (e) {
          projectObj = null;
        }
      }
    }

    if (!projectObj || !projectObj.targets) {
      return `#include <iostream>
#include <string>
#include <vector>

int main() {
    std::cout << "Welcome to Practido C++ Code Studio!" << std::endl;
    return 0;
}
`;
    }

    const allUsedMethods = new Set();
    const rawLines = [];

    projectObj.targets.forEach((target) => {
      const spriteName = target.name || "Sprite1";
      const cleanVarName = spriteName.toLowerCase().replace(/[^a-z0-9_]/g, "_");

      if (target.blocks) {
        const blocks = target.blocks;
        const topBlockKeys = Object.keys(blocks).filter(
          (k) => typeof blocks[k] === "object" && blocks[k].topLevel
        );

        topBlockKeys.forEach((topKey) => {
          const ctx = {
            targetLang: "cpp",
            varName: cleanVarName,
            indentLevel: 1,
            baseIndent: 1,
            lines: rawLines,
            usedMethods: allUsedMethods,
          };
          transpileBlock(topKey, blocks, ctx);
        });
      }
    });

    let cppLines = [
      "#include <iostream>",
      "#include <string>",
      "#include <vector>",
      "#include <thread>",
      "#include <chrono>",
      "",
      "void sleep_sec(double secs) {",
      "    std::this_thread::sleep_for(std::chrono::milliseconds(static_cast<int>(secs * 1000)));",
      "}",
      "",
    ];

    // Filter out any duplicated `int main() {` or `}` from rawLines
    const mainBodyLines = [];
    rawLines.forEach((line) => {
      const trimmed = line.trim();
      if (trimmed === "int main() {" || trimmed === "int main () {" || trimmed === "}") {
        return;
      }
      mainBodyLines.push(line.startsWith("    ") ? line : `    ${line}`);
    });

    cppLines.push("int main() {");
    if (mainBodyLines.length === 0) {
      cppLines.push("    std::cout << \"Practido C++ Program Initialized\" << std::endl;");
    } else {
      cppLines.push(...mainBodyLines);
    }
    cppLines.push("    return 0;");
    cppLines.push("}");

    return cppLines.join("\n");
  } catch (err) {
    return `// Error transpiling Scratch to C++: ${err.message}`;
  }
};

